import Marionette from 'backbone.marionette';
import Sidechain from '@nprapps/sidechain';
import config from './config/config';

// set up child responsive iFrame
let guest = Sidechain.registerGuest({
  sentinel: "ajc-sidechain",
  polling: 200
});

// var pattern = {
//   sentinel: "ajc-sidechain",
//   type: "pageData"
// };
// var onSidechain = Sidechain.matchMessage(pattern, function(data) {
//   console.log("emd pattern analytics received!", data);
// });
// window.addEventListener("message", onSidechain);

// window.dataLayer = window.dataLayer || [];

// I'm not exactly sure when this is used vs Navigator.navigate but it seems like one or the other is running when navigating but not both, so we're doing a similar thing on Navigator.navgitate as well
Marionette.AppRouter = Marionette.AppRouter.extend({
  onRoute: function (eventName, path, args) {
    // path contains `:` before the ID of the item, args[0] is the actual ID you want in the URL
    let myPath = `${path.split(":")[0]}${args[0] ? args[0] : ''}`;
    // do NOT send message if there is no hash (i.e. probably the app just loaded in an iframe from scratch and if we go trying to update the parent while the parent is trying to also send its own hash it will get unpredictable)
    if (myPath) {
      console.log("EMD ROUTING via onRoute: ", arguments);
      guest.sendMessage({
        route: myPath
      });
    }
  }
});
var MainRegion = Marionette.Region.extend({
  el: "#main-region",
  onShow: function (view, region, options) {
    //every time a new view is shown in the main region, check for .tipped class and add tooltips
    view.on("show", function () {
      Navigator.$tooltip.hide(); //make sure there aren't any hanging around
      Navigator.addTips();
      window.scrollTo(0, 0); // otherwise scroll position from previous "page" will persist
    });
  }
});

var Navigator = new Marionette.Application({
  initialize: function () {
    this.$tooltip = $("#tooltip");
    this.guest = guest;
  },
  regions: {
    navbarRegion: "#navbar-region",
    loadingRegion: "#loading-region",
    mainRegion: MainRegion
  }
});
Navigator.config = config;
Navigator.navigate = function (route, options) {
  console.log("EMD ROUTING via navigate: ", arguments);
  options || (options = {});
  // give new route to parent iFrame to change parent URL
  // this isn't being called for certain filters like various bills views (I think it's because the watched bills are links instead of a collection and that's messing things up? Actually I don't think that's it but seems like primarily bills app stuff doesn't trigger it) so we're doing a similar thing for Marionette.AppRouter.onRoute as well -- EMD 1/11/24
  guest.sendMessage({
    route: route
  });
  Backbone.history.navigate(route, options);
};
Navigator.getCurrentRoute = function () {
  return Backbone.history.fragment;
};
Navigator.addTips = function () {
  $(".tipped").on("mouseover", function (e) {
    var tipdata = e.currentTarget.dataset; //store it on the element so if the user comes back it's already here
    //store title info in data
    if (!tipdata.tip) {
      let myTag = $(this).prop("tagName");
      if (myTag === "svg") {
        // the only way I've been able to get fontAwesome to play nice with bootstrap tooltips (and had to use the SVG method instead of <i>). We still do add tips to some images (like member mugs) so need to do both methods
        tipdata.tip = this.querySelector('title').innerHTML;
        this.querySelector('title').innerHTML = '';
      } else {
        tipdata.tip = e.target.title; //clear title attribute to prevent browser default tooltips
        e.target.title = ""; //clear title attribute to prevent browser default tooltips
      }

      tipdata.x = e.pageX;
      tipdata.y = e.pageY;
    }
    Navigator.$tooltip.show().html(tipdata.tip).css("top", +tipdata.y - e.offsetY - 50 + "px").css("left", +tipdata.x - textWidth() / 2 + "px");
    //calculate tooltip width for placement
    function textWidth() {
      // ????? this makes no sense and doesn't work
      var sensor = $('<div />').css({
        margin: 0,
        padding: 0
      });
      Navigator.$tooltip.append(sensor);
      var width = sensor.width();
      sensor.remove();
      return width;
    }
    ;
  }).on("mouseout", function () {
    Navigator.$tooltip.hide();
  });
};

// FIXME: this triggers whenever certain views are shown, even if they are being re-shown but with a filter, like the members filters (which are different from the filter parameter below, which finds a detail page based on an id)
/*  Navigator.updateAnalytics = function(page, filter){
    // Navigator.updateAnalytics needs to be called by each app
    // we are doing it that way because navigate runs anytime the route changes not just when a new section is entered (edit: That's not really true here since I don't think there are any routes that don't also load a new view but calling from Navigator.navigate doesn't seem to work reliably - this is a bit scary here though bc you have to remember to add the call *if* you create a new app)
   if(filter){
    console.log("EMD navigating with a filter: ", page, filter);
      page = page+"/"+filter;
    }
    //manually trigger a metrics interaction
    console.log("Navigating to: ", page);
    old google analytics code, no longer supported
    ga('set', {
      page: '/#'+page,
      title: page.charAt(0).toUpperCase() + page.substring(1).toLowerCase()
    });
    ga('send', 'pageview');

    // TODO: tried this here to see if it would make sense to track it on the child page instead of dealing with passing the events to parent but I don't think it does? Leaving until we confirm the parent-levle solution
  window.dataLayer.push({
    'event': 'virtualPageview',
    'pageUrl': '/#'+page,
    'pageTitle': page.charAt(0).toUpperCase() + page.substring(1).toLowerCase()
    });

  } */ // Navigator.updateAnalytics

Navigator.on("start", function () {
  if (Backbone.history) {
    Backbone.history.start();
  }
});
export { Navigator as default };